import React from "react";

import { helpers } from "services";
import { Avatar } from "components";
import get from "lodash/get";
import useTranslation from "hooks/useTranslation";

const TopClients = ({ items, defaultCurrency }) => {
  const { tr } = useTranslation();

  return (
    <div className="dashboard-panel h-100-percent">
      <div className="dashboard-panel__head">
        <div>{tr("Статистика Агентов")}</div>
      </div>
      <div className="dashboard-panel__body">
        {items.map(item => {
          return (
            <div className="d-flex align-items-center justify-content-between mb-10 border-bottom pb-10">
              <div className="d-flex align-items-center">
                <Avatar
                  image={get(item, "file.thumbnails.small.srcs")}
                  isProduct={false}
                />
                <div className="pl-10 pr-20">
                  <div className="fs-14 fw-700">{get(item, "user.name")}</div>
                </div>
              </div>
              <div className="text-right fw-700 fs-14 ws-no-wrap">
                {helpers.convertToReadable(Number(item.tip_price))}{" "}
                {defaultCurrency && defaultCurrency.toUpperCase()}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TopClients;
